<template>
  <div
    class="d-flex justify-content-between flex-wrap gap-5 nav-line-tabs border-0"
  >
    <ul
      class="nav nav-tabs fs-6 d-flex flex-nowrap flex-grow-1 border-0 d-flex justify-content-between"
    >
      <div class="d-flex gap-0 navbar-navigation-buttons">
        <li class="left-tab-padding"></li>
        <li
          v-for="tab in tabs"
          :key="tab.value"
          class="nav-item"
          :class="`${selectedTab === tab.value ? 'active' : ''}`"
        >
          <a
            class="nav-link cursor-pointer text-nowrap fs-5 d-flex align-items-center"
            :class="`${tab.disabled ? 'disabled text-muted' : ''}`"
            :disabled="tab.disabled"
            @click="onTabSelected(tab.value)"
          >
            {{ tab.title }}
          </a>
        </li>
      </div>
      <div
        class="d-flex flex-grow-1 justify-content-end gap-3 navbar-utility-buttons"
      >
        <button
          v-if="currentTabIsResultsTab"
          class="btn btn-link p-0 w-25px"
          @click="handleChangeViewMode('slideshow')"
        >
          <i class="bi bi-arrows-fullscreen hover-primary py-1 px-2"></i>
        </button>

        <button
          v-if="currentTabIsResultsTab && shouldShowNotebook"
          class="btn btn-link p-0 w-25px"
          @click="toggleNotes"
        >
          <i class="bi bi-journal-text fs-3 hover-primary py-1 px-2"></i>
        </button>

        <button
          v-if="currentTabIsResultsTab"
          class="btn btn-link p-0 w-25px"
          @click="goToResults"
        >
          <i class="bi bi-list fs-3 hover-primary py-1 px-2"></i>
        </button>
      </div>
    </ul>
  </div>
</template>

<script>
import { tabTypes } from '@/constants/tab-types'

export default {
  name: 'SurveyResultTabsNavigation',
  props: {
    selectedTab: {
      type: String,
      default: 'results'
    },
    onTabSelected: {
      type: Function,
      default: () => {}
    },
    userIsAdminForSelectedGroup: {
      type: Boolean,
      default: false
    },
    userIsPulsAdmin: {
      type: Boolean,
      default: false
    },
    userIsGroupAdmin: {
      type: Boolean,
      default: false
    },
    shouldShowNotebook: {
      type: Boolean,
      required: true
    },
    surveyContainsOnlyFreeTextQuestions: {
      type: Boolean,
      required: true
    }
  },
  emits: ['tabSelected', 'changeViewMode', 'toggleNotes', 'goToResults'],
  computed: {
    currentTabIsResultsTab() {
      return this.selectedTab === tabTypes.RESULTS
    },
    tabs() {
      const hiddenForNormalUser =
        !this.userIsGroupAdmin && !this.userIsPulsAdmin
      return [
        {
          value: tabTypes.RESULTS,
          title: this.$t('sections.resultsForSurvey.tabs.results.title'),
          hidden: this.surveyContainsOnlyFreeTextQuestions
        },
        {
          value: tabTypes.FREETEXT,
          title: this.$t('sections.resultsForSurvey.tabs.freetext.title'),
          adminOnly: true,
          disabled: !this.userIsAdminForSelectedGroup && !this.userIsPulsAdmin,
          hidden: hiddenForNormalUser
        },
        {
          value: tabTypes.COMPARISON,
          title: this.$t('sections.resultsForSurvey.tabs.compare.title'),
          adminOnly: true,
          showForAdminOfOtherGroup: true,
          disabled:
            !this.userIsAdminForSelectedGroup &&
            !this.userIsPulsAdmin &&
            !this.userIsGroupAdmin,
          hidden:
            hiddenForNormalUser || this.surveyContainsOnlyFreeTextQuestions
        },
        {
          value: tabTypes.EXPORT,
          title: this.$t('sections.resultsForSurvey.tabs.export.title'),
          adminOnly: true,
          disabled: !this.userIsAdminForSelectedGroup && !this.userIsPulsAdmin,
          hidden: hiddenForNormalUser
        }
      ].filter((tab) => !tab.hidden)
      // .filter((tab) => {
      //   return (
      //     !tab.adminOnly ||
      //     this.userIsAdminForSelectedGroup ||
      //     this.userIsPulsAdmin ||
      //     (this.userIsGroupAdmin && tab.showForAdminOfOtherGroup)
      //   )
      // })
    }
  },
  methods: {
    isResultsTab(tabValue) {
      return tabValue === tabTypes.RESULTS
    },
    handleChangeViewMode(viewMode) {
      this.$emit('changeViewMode', viewMode)
    },
    toggleNotes() {
      this.$emit('toggleNotes')
    },
    goToResults() {
      this.$emit('goToResults')
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-line-tabs {
  .left-tab-padding {
    width: 0.95rem;
    border-bottom: 1px solid var(--kt-card-border-color) !important;
  }

  .nav-item {
    margin-bottom: 0px;
    border: 2px solid transparent !important;
    background: var(--kt-card-bg);
    border-top-left-radius: 0.95rem !important;
    border-top-right-radius: 0.95rem !important;
    border: 1px solid var(--kt-card-border-color) !important;
    margin-right: -1px;

    &.active {
      border: 1px solid var(--kt-card-border-color) !important;
      border-bottom: 1px solid transparent !important;
      background: transparent !important;
      .nav-link {
        color: var(--kt-primary-active) !important;
      }
    }
    .nav-link {
      backdrop-filter: blur(5px);
      height: 40px;
      color: var(--kt-gray-800);

      &.disabled {
        background: var(--kt-input-disabled-bg);
      }
    }
  }
}
.nav-link {
  padding: 4px 15px !important;
  margin: 0px !important;

  border: none !important;
}
.w-25px {
  width: 25px;
}
.navbar-utility-buttons {
  border-bottom: 1px solid var(--kt-card-border-color);
}
</style>
